import { render } from "./RealEstateSingleGallery.vue?vue&type=template&id=caf58240&scoped=true"
import script from "./RealEstateSingleGallery.vue?vue&type=script&lang=js"
export * from "./RealEstateSingleGallery.vue?vue&type=script&lang=js"

import "./RealEstateSingleGallery.vue?vue&type=style&index=0&id=caf58240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf58240"]])

export default __exports__